<template>
    <div class="overview">
        <div class="content-layout">
            <div class="column column__large">
                <div class="block fullheight animated fadeIn">
                    <div class="title">
                        <i class="fal fa-motorcycle fa-fw" v-if="$store.state.carData.general.KoeretoejArtNavn === 'Motorcykel'" />
                        <i class="fal fa-car fa-fw" v-else />
                        Køretøjet
                    </div>
                    <div class="body">
                        <line-data title="Type" :value="$store.state.carData.general.KoeretoejArtNavn" />
                        <line-data title="Stelnummer" :value="$store.state.carData.general.StelNr" />
                        <line-data title="Status" :value="$store.state.carData.general.Status">
                            <span slot="extra">
                                d. {{ $store.state.carData.general.StatusDato | moment('D. MMMM YYYY') }}
                            </span>
                        </line-data>
                        <line-data title="Indregistreret" :value="$store.state.carData.general.FoersteRegistreringDato | moment('D. MMMM YYYY')" />
                        <!--<line-data title="km per år" value="0" />-->
                        <hr>
                        <div v-if="!$store.state.searching && $store.state.carData.lookups !== null">
                            Dette køretøj er blevet fremsøgt
                            <b v-if="!$store.state.loadingLookups && $store.state.carData.lookups !== null && $store.state.carData.lookups.count > 0">
                                {{ $store.state.carData.lookups.count }} gange
                            </b>
                            <b v-else>
                                1 gang
                            </b>
                            <span v-if="$store.state.carData.lookups && $store.state.carData.lookups.count > 0">
                                og senest d.
                                <b>
                                    {{ $store.state.carData.lookups.latest | moment('D. MMMM YYYY [kl.] HH:mm') }}
                                </b>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column column__small">
                <div class="block fullheight animated fadeIn">
                    <div class="title">
                        <i class="fal fa-clipboard-check fa-fw" />
                        Tjekliste
                    </div>
                    <div class="body">
                        <div class="checks" v-if="$store.state.match && !$store.state.loadingDmr && !$store.state.loadingInspection && !$store.state.loadingRegistry">
                            <div class="single-check neutral" v-if="$store.state.carData.registry.LaaneDokumenter.length > 0 && !$store.state.carData.dmr.BilenErLeaset">
                                <i class="fas fa-info fa-fw" />
                                <span>
                                    Der er restgæld i køretøjet
                                </span>
                            </div>
                            <div class="single-check good" v-if="$store.state.carData.registry.LaaneDokumenter.length === 0 && !$store.state.carData.dmr.BilenErLeaset">
                                <i class="fas fa-check fa-fw" />
                                <span>
                                    Ingen restgæld i køretøjet
                                </span>
                            </div>
                            <div class="single-check neutral" v-if="$store.state.carData.dmr.BilenErLeaset">
                                <i class="fas fa-info fa-fw" />
                                <span>
                                    Køretøjet er leaset
                                    <br>
                                    ({{ $store.state.carData.general.LeasingGyldigFra | moment('DD/MM/YYYY') }}
                                    -
                                    {{ $store.state.carData.general.LeasingGyldigTil | moment('DD/MM/YYYY') }})
                                </span>
                            </div>
                            <div class="single-check good" v-if="$store.state.carData.wanted !== null && $store.state.carData.wanted.PoliceWantedStatus === 1 || !$store.state.carData.wanted">
                                <i class="fas fa-check fa-fw" />
                                <span>
                                    Køretøjet er ikke efterlyst
                                </span>
                            </div>
                            <div class="single-check bad" v-if="$store.state.carData.wanted !== null && $store.state.carData.wanted.PoliceWantedStatus === 0">
                                <i class="fas fa-exclamation fa-fw" />
                                <span>
                                    Køretøjet er efterlyst
                                </span>
                            </div>
                            <div class="single-check neutral" v-if="$store.state.carData.inspection !== null && $store.state.carData.inspection.MistaenkeligtKmStand && $store.state.carData.inspection">
                                <i class="fas fa-info fa-fw" />
                                <span>
                                    Mistænkelig km-stand
                                </span>
                            </div>
                            <div class="single-check good" v-if="$store.state.carData.inspection !== null && !$store.state.carData.inspection.MistaenkeligtKmStand && $store.state.carData.inspection">
                                <i class="fas fa-check fa-fw" />
                                <span>
                                    Ingen mistanke om km-fusk
                                </span>
                            </div>
                            <div class="single-check good" v-if="$store.state.carData.inspection && $store.state.carData.inspection.Rapporter.length > 0 && $store.state.carData.inspection.Rapporter[0].Synsresultat === 'Godkendt'">
                                <i class="fas fa-check fa-fw" />
                                <span>
                                    Køretøjet bestod sidste syn
                                </span>
                            </div>
                            <div class="single-check neutral" v-if="$store.state.carData.inspection && $store.state.carData.inspection.Rapporter.length > 0 && $store.state.carData.inspection.Rapporter[0].Synsresultat === 'Betinget godkendt'">
                                <i class="fas fa-info fa-fw" />
                                <span>
                                    "Betinget godkendt" ved sidste syn
                                </span>
                            </div>
                            <div class="single-check neutral" v-if="$store.state.carData.inspection && $store.state.carData.inspection.Rapporter.length > 0 && $store.state.carData.inspection.Rapporter[0].Synsresultat === 'Middel'">
                                <i class="fas fa-info fa-fw" />
                                <span>
                                    "Middel" ved sidste syn
                                </span>
                            </div>
                            <div class="single-check bad" v-if="$store.state.carData.inspection && $store.state.carData.inspection.Rapporter.length > 0 && $store.state.carData.inspection.Rapporter[0].Synsresultat !== 'Godkendt' && $store.state.carData.inspection.Rapporter[0].Synsresultat !== 'Betinget godkendt' && $store.state.carData.inspection.Rapporter[0].Synsresultat !== 'Middel'">
                                <i class="fas fa-exclamation fa-fw" />
                                <span>
                                    Bestod ikke sidste syn
                                </span>
                            </div>
                            <div class="single-check good" v-if="$store.state.carData.inspection && $store.state.carData.inspection.Rapporter.length === 0">
                                <i class="fas fa-check fa-fw" />
                                <span>
                                    Endnu ikke synet
                                </span>
                            </div>
                            <div class="single-check neutral" v-if="!$store.state.carData.inspection">
                                <i class="fas fa-info fa-fw" />
                                <span>
                                    Ingen synsdata
                                </span>
                            </div>
                            <div class="single-check good" v-if="$store.state.carData.dmr.Forsikring.Status !== null && $store.state.carData.dmr.Forsikring.Status === 'Aktiv' && $store.state.carData.general.Status !== 'Afmeldt'">
                                <i class="fas fa-check fa-fw" />
                                <span>
                                    Køretøjet er forsikret
                                </span>
                            </div>
                            <div class="single-check bad" v-if="$store.state.carData.dmr.Forsikring.Status !== null && $store.state.carData.dmr.Forsikring.Status !== 'Aktiv' && $store.state.carData.general.Status !== 'Afmeldt'">
                                <i class="fas fa-exclamation fa-fw" />
                                <span>
                                    Køretøjet er ikke forsikret
                                </span>
                            </div>
                            <div class="single-check neutral" v-if="!$store.state.carData.dmr.Forsikring.Status">
                                <i class="fas fa-info fa-fw" />
                                <span>
                                    Ingen forsikringsoplysninger
                                </span>
                            </div>
                            <div class="single-check bad" v-if="$store.state.carData.dmr.Forsikring.Selskab === 'SELVFORSIKRING'">
                                <i class="fal fa-exclamation fa-fw" />
                                <span>
                                    Muligvis en civil politibil
                                </span>
                            </div>
                            <div class="single-check neutral" v-if="$store.state.carData.general.Status && $store.state.carData.general.Status === 'Afmeldt'">
                                <i class="fal fa-info fa-fw" />
                                <span>
                                    Køretøjet er afmeldt
                                </span>
                            </div>
                        </div>
                        <data-loader v-else title="Henter data" />
                    </div>
                </div>
            </div>
        </div>
        <div class="content-layout">
            <div class="column column__third">
                <div class="block fullheight animated fadeIn delay-1s">
                    <div class="title">
                        <i class="fal fa-clipboard-list-check fa-fw" />
                        Syn
                    </div>
                    <div class="body" v-if="!$store.state.loadingInspection && !$store.state.loadingDmr">
                        <line-data title="Sidste syn" :value="$store.state.carData.dmr.SidsteSyn | moment('D. MMMM YYYY')" v-if="$store.state.carData.dmr.SidsteSyn" />
                        <line-data title="Sidste syn" value="Endnu ikke synet" v-else />
                        <line-data title="Næste syn om" :value="daysUntilNextInspection" suffix="dage" />
                        <router-link tag="div" :to="{name: 'SearchReports'}" class="block-cta" @click.native="$scrollToTop">
                            Se alle synsrapporter
                            <span v-if="$store.state.carData.inspection.Rapporter && $store.state.carData.inspection.Rapporter.length > 0">
                                ({{ $store.state.carData.inspection.Rapporter.length }})
                            </span>
                            <i class="fas fa-chevron-right" />
                        </router-link>
                    </div>
                    <data-loader v-else title="Henter data fra Trafikstyrelsen" />
                </div>
            </div>
            <div class="column column__third">
                <div class="block fullheight animated fadeIn delay-1s">
                    <div class="title">
                        <i class="fal fa-envelope-open-dollar fa-fw" />
                        Afgift
                    </div>
                    <div class="body" v-if="!$store.state.loadingDmr">
                        <div v-if="$store.state.carData.dmr.Afgift.AfgiftDetaljer.length > 0">
                            <line-data title="Halvårlig afgift" :value="$store.state.carData.dmr.Afgift.AfgiftDetaljer[$store.state.carData.dmr.Afgift.AfgiftDetaljer.length - 1].Pris" v-if="$store.state.carData.dmr.Afgift.AfgiftDetaljer.length > 0 && $store.state.carData.dmr.Afgift.AfgiftDetaljer[0].Hyppighed === 'Halvårlig'" />
                            <line-data title="Halvårlig afgift" :value="$store.state.carData.dmr.Afgift.AfgiftDetaljer[$store.state.carData.dmr.Afgift.AfgiftDetaljer.length - 1].Pris" v-if="$store.state.carData.dmr.Afgift.AfgiftDetaljer.length === 0 && $store.state.carData.dmr.Afgift.AfgiftDetaljer[0].Hyppighed === 'Halvårlig'" />
                            <line-data title="Årlig afgift" :value="$store.state.carData.dmr.Afgift.AfgiftDetaljer[$store.state.carData.dmr.Afgift.AfgiftDetaljer.length - 1].Pris" v-if="$store.state.carData.dmr.Afgift.AfgiftDetaljer.length > 0 && $store.state.carData.dmr.Afgift.AfgiftDetaljer[0].Hyppighed === 'Årlig'" />
                            <line-data title="Årlig afgift" :value="$store.state.carData.dmr.Afgift.AfgiftDetaljer[$store.state.carData.dmr.Afgift.AfgiftDetaljer.length - 1].Pris" v-if="$store.state.carData.dmr.Afgift.AfgiftDetaljer.length === 0 && $store.state.carData.dmr.Afgift.AfgiftDetaljer[0].Hyppighed === 'Årlig'" />
                            <line-data title="Næste afgift om" :value="daysUntilNextCharge" suffix="dage" />
                            <router-link tag="div" :to="{name: 'SearchCharges'}" class="block-cta" @click.native="$scrollToTop">
                                Se alle opkrævede afgifter
                                <span v-if="$store.state.carData.dmr.Afgift && $store.state.carData.dmr.Afgift.OpkraevedeAfgifter.length > 0">
                                    ({{ $store.state.carData.dmr.Afgift.OpkraevedeAfgifter.length }})
                                </span>
                                <i class="fas fa-chevron-right" /> 
                            </router-link>
                        </div>
                        <div v-else>
                            Ingen afgiftsoplysninger
                        </div>
                    </div>
                    <data-loader v-else title="Henter data fra Motorregistret" />
                </div>
            </div>
            <div class="column column__small">
                <div class="block fullheight animated fadeIn delay-1s">
                    <div class="title">
                        <i class="fal fa-file-certificate fa-fw" />
                        Forsikring
                    </div>
                    <div class="body align-top" v-if="!$store.state.loadingDmr">
                        <div v-if="$store.state.carData.dmr.Forsikring.Status !== null">
                            <b style="display:block;margin-bottom:15px;">{{ $store.state.carData.dmr.Forsikring.Selskab }}</b>
                            <line-data title="Status" :value="$store.state.carData.dmr.Forsikring.Status" v-if="$store.state.carData.dmr.Forsikring !== null && $store.state.carData.dmr.Forsikring.Status !== 'Aktiv'" />
                            <line-data title="Oprettet" :value="insuranceDate | moment('D. MMM. YYYY')" v-else />
                            <div class="block-cta" @click="goToInsurancePartner('Samlino (link)')">
                                Beregn din forsikringspris
                                <i class="fas fa-external-link" />
                            </div>
                        </div>
                        <div v-if="$store.state.carData.dmr.Forsikring.Status === null">
                            Ingen forsikringsoplysninger
                            <br><br>
                            <div class="block-cta" @click="goToInsurancePartner('Samlino (link)')">
                                Beregn din forsikringspris
                                <i class="fas fa-external-link" />
                            </div>
                        </div>
                    </div>
                    <data-loader v-else title="Henter data fra Motorregistret" />
                </div>
            </div>
            <div class="column column__small mobile-partner animated fadeIn delay-1s" @click="goToInsurancePartner('Samlino (mobil billede)')">
                <div class="block">
                    <img src="/static/partners/samlino-500x500.jpg" style="width:100%;" />
                </div>
            </div>
            <!--<div v-if="randomNumber === 2" class="column column__small mobile-partner animated fadeIn delay-1s" @click="goToCasinoPartner('Leo Vegas (mobil billede)')">
                <div class="block">
                    <img src="/static/partners/leovegas-square.jpg" style="width:100%;" />
                </div>
            </div>-->
        </div>
        <div class="content-layout">
            <div class="column column__medium">
                <div class="block fullheight animated fadeIn delay-2s">
                    <div class="title">
                        <i class="fal fa-cog fa-fw" />
                        Motor
                    </div>
                    <div class="body">
                        <line-data title="Brændstofforbrug" :value="$store.state.carData.general.MotorKmPerLiter" suffix="km/l" />
                        <line-data v-if="$store.state.carData.general.DrivkraftTypeNavn === 'El'" title="Elektrisk forbrug" :value="$store.state.carData.general.MotorElektriskForbrug" suffix="Wh/km" />
                        <line-data title="Brændstof type" :value="$store.state.carData.general.DrivkraftTypeNavn" />
                        <line-data title="Antal cylindre" :value="$store.state.carData.general.MotorCylinderAntal" />
                        <line-data title="Slagvolumen" :value="$store.state.carData.general.MotorSlagVolumen" suffix="cm<sup>3</sup>">
                            <span slot="extra" v-if="$store.state.carData.general.MotorStoerrelse">
                                ({{ $store.state.carData.general.MotorStoerrelse }}L)
                            </span>
                        </line-data>
                        <line-data title="Hestekræfter" :value="$store.state.carData.general.MotorStoersteEffekt * 1.3636363636 | rounded" suffix="HK" />
                        <line-data title="Max hastighed" :value="$store.state.carData.general.MaksimumHastighed" suffix="km/t" />
                        <router-link tag="div" :to="{name: 'SearchTechnicalInfo'}" class="block-cta" @click.native="$scrollToTop">
                            Se alle tekniske specifikationer
                            <i class="fas fa-chevron-right" /> 
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="column column__medium">
                <div class="block fullheight animated fadeIn delay-2s" style="position:relative;">
                    <div class="economy-fields-toggle absolute">
                        <div v-if="!showEconomyFields" @click="showEconomyFields = true">
                            <i class="fas fa-pencil" />
                            Beregn din økonomi
                        </div>
                    </div>
                    <div class="title">
                        <i class="fal fa-sack-dollar fa-fw" />
                        Økonomi
                    </div>
                    <div class="body economy">
                        <div v-if="!showEconomyFields">
                            <div class="economy-fields-toggle mobile">
                                <div v-if="!showEconomyFields" @click="showEconomyFields = true">
                                    <i class="fas fa-pencil" />
                                    Beregn din økonomi
                                </div>
                            </div>
                            <line-data title="Brændstof" :value="totalFuel | currency" suffix="kr." />
                            <line-data title="Service & vedligeholdelse" :value="totalMaintenance | currency" suffix="kr." />
                            <line-data title="Forsikring" :value="totalInsurance | currency" suffix="kr." />
                            <line-data title="Afgift" :value="totalCharges | currency" suffix="kr." />
                            <line-data title="Afdrag på lån" :value="calculator.monthlyLoan | currency" suffix="kr." v-if="calculator.monthlyLoan > 0" />
                            <line-data class="big-text" title="Total pr. måned" :value="totalExpensePerMonth | currency" suffix="kr." />
                            <hr>
                            <div style="opacity:.5;font-size:12px;">
                                Beregningerne er baseret på den gennemsnitlige danskers kørselsvaner og udgifter sammenholdt med dette køretøjs data.
                            </div>
                        </div>
                        <div class="budget" v-else>
                            <line-data title="Km kørt pr. år" value="donotshow" :alignCenter="true" type="km">
                                <div slot="extra"></div>
                                <input type="number" class="form-control type-km" slot="extra" v-model="calculator.kmPerYear" min="0" max="100000" step="1000" inputmode="numeric" pattern="[0-9]*" />
                            </line-data>
                            <line-data title="Service & vedl. pr. km (kr.)" value="donotshow" :alignCenter="true" type="kr">
                                <div slot="extra"></div>
                                <input type="number" class="form-control" slot="extra" v-model="calculator.maintenancePerKm" min="0" max="1" step="0.10" inputmode="numeric" pattern="[0-9]*" />
                            </line-data>
                            <line-data title="Årlig forsikring (kr.)" value="donotshow" :alignCenter="true" type="kr">
                                <div slot="extra"></div>
                                <input type="number" class="form-control" slot="extra" v-model="calculator.insurance" min="0" max="100000" step="1000" inputmode="numeric" pattern="[0-9]*" />
                                <div slot="newline">
                                    <a class="block-cta" href="javascript:void(0)" @click="goToInsurancePartner('Samlino (Økonomi link)')">
                                        Beregn din forsikringspris
                                        <i class="fas fa-external-link" />
                                    </a>
                                </div>
                            </line-data>
                            <line-data title="Afdrag på lån pr. måned (kr.)" value="donotshow" :alignCenter="true" type="kr">
                                <div slot="extra"></div>
                                <input type="number" class="form-control" slot="extra" v-model="calculator.monthlyLoan" min="0" max="30000" step="500" inputmode="numeric" pattern="[0-9]*" />
                                <div slot="newline">
                                    <a class="block-cta" href="javascript:void(0)" @click="goToLoanPartner('Økonomi link')">
                                        <span v-if="$store.state.carData.general.KoeretoejArtNavn === 'Motorcykel'">
                                            Beregn dit MC-lån
                                            <i class="fas fa-external-link" />
                                        </span>
                                        <span v-else>
                                            Beregn dit billån
                                            <i class="fas fa-external-link" />
                                        </span>
                                    </a>
                                </div>
                            </line-data>
                            <div class="economy-fields-toggle" @click="showEconomyFields = false">
                                <i class="fas fa-save" />
                                Gem og vis resultat
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../../../styles/vars";

@keyframes custom-pulse {
    0% {
        transform: scale(1);
    }
    60% {
        transform: scale(1);
    }
    70% {
        transform: scale(1.05);
    }
    80% {
        transform: scale(1);
    }
    90% {
        transform: scale(1.05);
    }
    100% {
        transform: scale(1);
    }

}

    .overview {

        .block.overview {
            
            .block__title {
                opacity: .5;
                font-weight: 400;
                text-transform: uppercase;
            }

            .block__value {
                font-size: 30px;
                font-weight: 600;
                margin-bottom: -10px;

                span {
                    font-size: 14px;
                    font-weight: 400;
                }
            }
        }

        .mobile-partner {
            display: none;

            @media screen and (max-width: $small) {
                display: block;
            }

            .block {
                padding: 0;
                border-radius: 5px;

                img {
                    border-radius: 5px;
                    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);
                }
            }
        }

        .economy-fields-toggle {
            font-weight: 600;
            color: $color--main;
            cursor: pointer;

            &.absolute {
                position: absolute;
                top: 35px;
                right: 30px;
                animation: custom-pulse 3s ease-in-out infinite;

                @media screen and (max-width: $small) {
                    display: none;
                }
            }

            &.mobile {
                display: none;
                margin-bottom: 15px;

                @media screen and (max-width: $small) {
                    display: block;
                }
            }

            &:not(.absolute) {
                padding-top: 15px;
            }

            &:hover {
                color: darken($color--main, 10%);
            }
        }

        .possibly-police {
            color: $color--red;
            font-weight: 600;
        }

        .block.image {
            // padding: 0;
            overflow: hidden;

            img {
                width: 100%;
                border-radius: 4px;
            }
            /* min-height: 250px;
            display: flex;
            justify-content: center;
            align-items: center; */
        }

        .block-cta {
            color: $color--main;
            font-weight: 600;
            // text-align: center;
            padding-top: 15px;
            // margin-top: 15px;
            // border-top: 1px solid rgba(0, 0, 0, 0.05);
            cursor: pointer;

            &:hover {
                text-decoration: underline;
            }
        }

        .block.fullheight {
            height: calc(100% - 30px);
        }

        .economy {

            .budget {

                .line {

                    @media screen and (max-width: $small) {
                        display: block;
                    }
                }
            }
            
            .line {

                &:last-of-type {
                    // font-size: 20px;
                }
            }
        }

        .checks {

            .single-check {
                font-weight: 600;
                display: flex;
                align-items: center;
                padding-top: 5px;

                i {
                    font-size: 20px;
                }

                span {
                    padding-left: 15px;
                }

                &:not(:last-of-type) {
                    margin-bottom: 15px;
                }

                &.good {
                    color: $color--green;
                }

                &.neutral {
                    color: $color--orange;
                }

                &.bad {
                    color: $color--red;
                }
            }
        }
    }

</style>


<script>
import * as lookupService from '@/services/lookup/lookupService'
import * as vehicleService from '@/services/vehicle/vehicleService'
import * as imageService from '@/services/image/imageService'
import moment from 'moment'
import axios from 'axios'

export default {
    data () {
        return {
            randomNumber: null,
            latestLookups: null,
            vehicles: null,
            image: null,
            showEconomyFields: false,
            calculator: {
                kmPerYear: 20000,
                gasPrice: 11,
                maintenancePerKm: 0.5,
                insurance: 8000,
                monthlyLoan: 0
            }
        }
    },
    mounted () {
        this.getLatestLookups()
        this.getAllVehicles()
        this.randomNumber = Math.floor((Math.random() * 2) + 1)
    },
    methods: {
        getLatestLookups () {
            lookupService.findAll({}, (response) => {
                this.latestLookups = response.data.rows
            }, (err) => {
                console.log(err)
            })
        },
        getAllVehicles () {
            vehicleService.findAll({}, (response) => {
                this.vehicles = response.data
            })
        },
        searchCarImage () {
            let brand = encodeURI(this.$store.state.carData.general.MaerkeTypeNavn)
            let model = encodeURI(this.$store.state.carData.general.ModelTypeNavn)
            // let year = moment(this.$store.state.carData.general.FoersteRegistreringDato).format('YYYY')
            let searchString = brand + '+' + model
            imageService.find(searchString, {}, (response) => {
                // console.log(response.data)
                let formattedString = response.data.substr(79)
                let formattedStringSecond = formattedString.substr(0, formattedString.length - 9)
                this.image = formattedStringSecond
            })
        },
        goToInsurancePartner (name) {
            let numberplate = this.$store.state.licenseplate.split(' ').join('').toUpperCase()
            // let link = 'https://ad.doubleclick.net/ddm/trackclk/N861970.2126501SAMLINO.DK/B22969279.250543226;dc_trk_aid=446948115;dc_trk_cid=118543082?https://www.samlino.dk/bilforsikring/indhentpriser?knowLicensePlateNum=true&licensePlateNumUq=' + numberplate + '&utm_source=nrpladetjek&utm_medium=cpc&utm_campaign=ciweek28_19'
            let link = 'https://online.adservicemedia.dk/cgi-bin/click.pl?pid=33267&cid=7110&productGroup=Samlino&media_id=83530'
            if (process.env.NODE_ENV === 'production') {
                if ('ga' in window) {
                    let tracker = window.ga.getAll()[0]
                    if (tracker) {
                        tracker.send('event', 'Affiliate', 'Samlino')
                    }
                }
                let formattedText = ':male-detective: Affiliate klik på *' + name + '* med nrplade: ' + numberplate
                axios.post('https://hooks.slack.com/services/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', {
                    username: 'NrPladeTjek.dk',
                    icon_url: 'https://nrpladetjek.dk/static/apple-icon.png',
                    text: formattedText
                    },
                    {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })
                if ('ga' in window) {
                    let tracker = window.ga.getAll()[0]
                    if (tracker) {
                        tracker.send('event', 'Affiliate', 'Klik', name)
                    }
                }
            }
            window.open(link, '_blank')
        },
        goToBroadbandPartner (name) {
            let numberplate = this.$store.state.licenseplate.split(' ').join('').toUpperCase()
            let link = 'https://online.adservicemedia.dk/cgi-bin/click.pl?pid=33267&cid=9581&productGroup=Fastspeed&media_id=83530'
            if (process.env.NODE_ENV === 'production') {
                if ('ga' in window) {
                    let tracker = window.ga.getAll()[0]
                    if (tracker) {
                        tracker.send('event', 'Affiliate', 'Fastspeed')
                    }
                }
                let formattedText = ':male-detective: Affiliate klik på *' + name + '* med nrplade: ' + numberplate
                axios.post('https://hooks.slack.com/services/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', {
                    username: 'NrPladeTjek.dk',
                    icon_url: 'https://nrpladetjek.dk/static/apple-icon.png',
                    text: formattedText
                    },
                    {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })
                if ('ga' in window) {
                    let tracker = window.ga.getAll()[0]
                    if (tracker) {
                        tracker.send('event', 'Affiliate', 'Klik', name)
                    }
                }
            }
            window.open(link, '_blank')
        },
        goToCasinoPartner (name) {
            let link = 'https://online.adservicemedia.dk/cgi-bin/click.pl?pid=33267&cid=7474&productGroup=leovegas'
            if (process.env.NODE_ENV === 'production') {
                if ('ga' in window) {
                    let tracker = window.ga.getAll()[0]
                    if (tracker) {
                        tracker.send('event', 'Affiliate', 'Leo Vegas')
                    }
                }
                let formattedText = ':male-detective: Affiliate klik på *' + name + '*'
                axios.post('https://hooks.slack.com/services/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', {
                    username: 'NrPladeTjek.dk',
                    icon_url: 'https://nrpladetjek.dk/static/apple-icon.png',
                    text: formattedText
                    },
                    {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })
                if ('ga' in window) {
                    let tracker = window.ga.getAll()[0]
                    if (tracker) {
                        tracker.send('event', 'Affiliate', 'Klik', name)
                    }
                }
            }
            window.open(link, '_blank')
        },
        goToBilmagasinet (from) {
            /* let licenseplate = this.$store.state.licenseplate.split(' ').join('').toUpperCase()
            let link = 'https://www.samlino.dk/bilforsikring/indhentpriser?knowLicensePlateNum=true&licensePlateNumUq=' + licenseplate + '&utm_source=nrpladetjek.dk&utm_medium=cpc' */
            let link = 'https://online.adservicemedia.dk/cgi-bin/click.pl?pid=33267&cid=9340&productGroup=bonnier'
            if (process.env.NODE_ENV === 'production') {
                let formattedText = ':male-detective: Affiliate klik på *' + 'Bil Magasinet (' + from + ')' + '*'
                axios.post('https://hooks.slack.com/services/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', {
                    username: 'NrPladeTjek.dk',
                    icon_url: 'https://nrpladetjek.dk/static/apple-icon.png',
                    text: formattedText
                    },
                    {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })
                if ('ga' in window) {
                    let tracker = window.ga.getAll()[0]
                    if (tracker) {
                        tracker.send('event', 'Affiliate', 'Klik', 'Bil Magasinet (' + from + ')')
                    }
                }
            }
            window.open(link, '_blank')
        },
        goToLoanPartner (from) {
            /* let licenseplate = this.$store.state.licenseplate.split(' ').join('').toUpperCase()
            let link = 'https://www.samlino.dk/bilforsikring/indhentpriser?knowLicensePlateNum=true&licensePlateNumUq=' + licenseplate + '&utm_source=nrpladetjek.dk&utm_medium=cpc' */
            // let link = 'http://online.digital-advisor.com/SH4B4'
            let link = 'https://online.adservicemedia.dk/cgi-bin/click.pl?pid=33267&cid=9364&productGroup=autol%EF%BF%BDnet&media_id=83530'
            if (process.env.NODE_ENV === 'production') {
                let formattedText = ':male-detective: Affiliate klik på *' + 'Santander (' + from + ')' + '*'
                axios.post('https://hooks.slack.com/services/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', {
                    username: 'NrPladeTjek.dk',
                    icon_url: 'https://nrpladetjek.dk/static/apple-icon.png',
                    text: formattedText
                    },
                    {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })
                if ('ga' in window) {
                    let tracker = window.ga.getAll()[0]
                    if (tracker) {
                        tracker.send('event', 'Affiliate', 'Klik', 'Santander (' + from + ')')
                    }
                }
            }
            window.open(link, '_blank')
        }
    },
    computed: {
        sortedLatestLookups () {
            this.latestLookups.forEach((lookup) => {
                lookup.fromNow = moment(lookup.createdAt).fromNow()
            })
            return this.latestLookups
        },
        sortedVehicles () {
            function compare (a, b) {
                if (a.horsepower < b.horsepower) {
                    return 1
                }
                if (a.horsepower > b.horsepower) {
                    return -1
                }
                return 0
            }
            return this.vehicles.sort(compare)
        },
        monthlyExpense () {
            let consumption = (this.calculator.kmPerYear / this.$store.state.carData.general.MotorKmPerLiter) * 11
            let serviceAndRepairs = (this.calculator.kmPerYear / 100) * this.expensePerHundredKm
            let payoff = this.calculator.payoff * 12
            let insurance = this.calculator.insurance
            return Number((consumption + serviceAndRepairs + payoff + insurance) / 12).toFixed(0)
        },
        daysUntilNextInspection () {
            if (this.$store.state.carData !== null && this.$store.state.carData.dmr.NaesteSyn) {
                let nextInspectionDate = moment(this.$store.state.carData.dmr.NaesteSyn, 'YYYY-MM-DD').format('X')
                let today = moment(new Date()).format('X')
                let result = Math.round((nextInspectionDate - today) / 86400) + 1
                if (result < 0) {
                    return false
                } else {
                    return result
                }
            } else {
                return false
            }
        },
        daysUntilNextCharge () {
            if (this.$store.state.carData !== null && this.$store.state.carData.dmr.Afgift.OpkraevedeAfgifter.length > 0) {
                let lastChargeEndDate = moment(this.$store.state.carData.dmr.Afgift.OpkraevedeAfgifter[0].DaekkerTil, 'DD-MM-YYYY').format('X')
                let today = moment(new Date()).format('X')
                let result = Math.round((lastChargeEndDate - today) / 86400) + 2
                if (result < 0) {
                    return false
                } else {
                    return result
                }
            } else {
                return false
            }
        },
        yearlyExpense () {
            return 1000
        },
        savingsWithShellCard () {
            if (this.totalFuel) {
                let liters = (this.totalFuel / this.calculator.gasPrice) * 12
                let savings = liters * 0.15
                return Math.round(savings)
            } else {
                return false
            }
        },
        totalFuel () {
            if (this.$store.state.carData.general.MotorKmPerLiter) {
                let litersPerYear = this.calculator.kmPerYear / this.$store.state.carData.general.MotorKmPerLiter
                let expensePerMonth = (litersPerYear * this.calculator.gasPrice) / 12
                return Math.round(expensePerMonth).toFixed(0)
            } else {
                return false
            }
        },
        totalMaintenance () {
            let expensePerMonth = (this.calculator.kmPerYear / 12) * this.calculator.maintenancePerKm
            return Math.round(expensePerMonth).toFixed(0)
        },
        totalInsurance () {
            let expensePerMonth = this.calculator.insurance / 12
            return Math.round(expensePerMonth).toFixed(0)
        },
        totalCharges () {
            if (this.$store.state.match && !this.$store.state.loadingDmr && this.$store.state.carData !== null && this.$store.state.carData.dmr.Afgift.AfgiftDetaljer.length > 0) {
                let sum = this.$store.state.carData.dmr.Afgift.AfgiftDetaljer[this.$store.state.carData.dmr.Afgift.AfgiftDetaljer.length - 1].Pris
                let a = sum.replace('.', '', -1)
                let b = a.replace(',', '.', -1)
                let c = b.substring(0, b.length - 4)
                if (this.$store.state.carData.dmr.Afgift.AfgiftDetaljer.length > 0 && this.$store.state.carData.dmr.Afgift.AfgiftDetaljer[0].Hyppighed === 'Halvårlig') {
                    return Number(c / 6).toFixed(0)
                } else if (this.$store.state.carData.dmr.Afgift.AfgiftDetaljer.length > 0 && this.$store.state.carData.dmr.Afgift.AfgiftDetaljer[0].Hyppighed === 'Årlig') {
                    return Number(c / 12).toFixed(0)
                } else {
                    return false
                }
            } else {
                return false
            }
        },
        totalExpensePerMonth () {
            let total = 0
            if (this.totalFuel) {
                total = total + Number(this.totalFuel)
            }
            if (this.totalMaintenance) {
                total = total + Number(this.totalMaintenance)
            }
            if (this.totalInsurance) {
                total = total + Number(this.totalInsurance)
            }
            if (this.totalCharges) {
                total = total + Number(this.totalCharges)
            }
            if (this.calculator.monthlyLoan > 0) {
                total = total + Number(this.calculator.monthlyLoan)
            }
            return total.toFixed(0)
        },
        insuranceDate () {
            let date = moment(this.$store.state.carData.dmr.Forsikring.Oprettet, 'DD-MM-YYYY').format('YYYY-MM-DD')
            return date
        }
    }
}
</script>




// WEBPACK FOOTER //
// overview.vue?c03df054